<div class="node-icon not-visited">
	<span class="node-icon-connector"></span>
</div>
